class CartEnhancements {
  constructor() {
    this._addInFlight = false;
    this.init();
  }

  init() {
    this.bindUpsellAddButtons();
    this.subscribeToCartUpdates();
  }

  bindUpsellAddButtons() {
    document.addEventListener('click', (e) => {
      const addButton = e.target.closest('.cart-upsell__add-button');
      if (!addButton || addButton.disabled || addButton.classList.contains('adding') || addButton.getAttribute('href')) return;
      if (this._addInFlight) {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      this.addToCart(addButton);
    });
  }

  async addToCart(button) {
    const variantId = button.dataset.variantId;
    const sellingPlanId = button.dataset.sellingPlanId;
    const prenatalPlan = button.dataset.prenatalPlan;
    const upsellKind = button.dataset.upsellKind;
    const productTitle = button.dataset.productTitle;

    if (!variantId) return;
    if (this._addInFlight) return;

    this._addInFlight = true;
    button.classList.add('adding');
    button.disabled = true;

    const addText = button.querySelector('.cart-upsell__add-text');
    const addingText = button.querySelector('.cart-upsell__adding-text');

    if (addText) addText.style.display = 'none';
    if (addingText) addingText.style.display = 'block';

    try {
      const item = {
          id: variantId,
          quantity: 1
      };

      if (sellingPlanId) item.selling_plan = sellingPlanId;
      if (prenatalPlan) item.properties = { _ir_prenatal_plan: prenatalPlan };

      const formData = {
        items: [item]
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error('Failed to add item to cart');
      }

      const data = await response.json();

      if (upsellKind === 'monthly-upgrade') {
        await this.replacePrenatalMonthlySubscription(data.items?.[0]);
      }

      this.hideAddedUpsellProduct(button);
      this.showSuccessMessage(productTitle);

      await this.updateCart();
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.showErrorMessage();
      button.classList.remove('adding');
      button.disabled = false;
      if (addText) addText.style.display = '';
      if (addingText) addingText.style.display = 'none';
    }
    this._addInFlight = false;
  }

  async replacePrenatalMonthlySubscription(addedUpgradeLine) {
    try {
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) {
        throw new Error('Failed to read cart before replacing monthly subscription');
      }

      const cart = await cartResponse.json();
      const monthlyLine = cart.items.find(item => (
        String(item.variant_id) === '43782910148678'
        && item.properties?._ir_prenatal_plan === 'monthly'
      ));

      if (!monthlyLine) return;

      const changeResponse = await this.changeCartLine(monthlyLine.key, 0);
      if (!changeResponse.ok) {
        throw new Error('Failed to remove monthly subscription during upgrade');
      }
    } catch (error) {
      if (addedUpgradeLine?.key) {
        const rollbackResponse = await this.changeCartLine(addedUpgradeLine.key, 0);
        if (!rollbackResponse.ok) {
          console.error('Failed to roll back 90-day subscription after upgrade error');
        }
      }
      throw error;
    }
  }

  changeCartLine(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: lineKey, quantity })
    });
  }

  async updateCart() {
    try {
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();

      this.updateProgressBar(cart);
      this.filterUpsellsByCart(cart);

      const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      if (cartItems && typeof cartItems.onCartUpdate === 'function') {
        cartItems.onCartUpdate(true, cart);
      }

      const cartIconBubble = document.querySelector('cart-icon-bubble');
      if (cartIconBubble) {
        const bubble = cartIconBubble.querySelector('.cart-count-bubble span');
        if (bubble) {
          bubble.textContent = cart.item_count;
        }
      }
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

  updateProgressBar(cart) {
    if (typeof window.irCartShippingApplyCountry === 'function') {
      window.irCartShippingApplyCountry();
    }

    const bars = document.querySelectorAll('[data-free-shipping-bar]');
    if (!bars.length) return;

    const visibleBar = Array.from(bars).find(bar => !bar.hidden && bar.offsetParent !== null);
    if (!visibleBar) return;

    const thresholdFromData = visibleBar.dataset.threshold;
    const freeShippingThreshold = thresholdFromData && parseInt(thresholdFromData, 10) > 0
      ? parseInt(thresholdFromData, 10)
      : 4400;

 const cartTotal = cart && typeof cart.total_price === 'number'
  ? cart.total_price
  : 0;

    const remainingAmount = freeShippingThreshold - cartTotal;
    const progressPercentage = Math.min((cartTotal / freeShippingThreshold) * 100, 100);
    
    const checkmarkIcon = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" fill="currentColor"/></svg>`;
    const truckIcon = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M19.5 8H17V6C17 4.34 15.66 3 14 3H6C4.34 3 3 4.34 3 6V15C3 16.1 3.9 17 5 17C5 18.66 6.34 20 8 20C9.66 20 11 18.66 11 17H15C15 18.66 16.34 20 18 20C19.66 20 21 18.66 21 17H22C22.55 17 23 16.55 23 16V12.67C23 12.24 22.86 11.82 22.6 11.47L20.3 8.4C20.11 8.15 19.81 8 19.5 8ZM8 18.5C7.17 18.5 6.5 17.83 6.5 17C6.5 16.17 7.17 15.5 8 15.5C8.83 15.5 9.5 16.17 9.5 17C9.5 17.83 8.83 18.5 8 18.5ZM18 18.5C17.17 18.5 16.5 17.83 16.5 17C16.5 16.17 17.17 15.5 18 15.5C18.83 15.5 19.5 16.17 19.5 17C19.5 17.83 18.83 18.5 18 18.5ZM17 12V9.5H19.5L21.47 12H17Z" fill="currentColor"/></svg>`;
    
    const messageHtml = remainingAmount > 0
      ? `${truckIcon}<span>Add <strong>${this.formatMoney(remainingAmount)}</strong> more for free shipping</span>`
      : `${checkmarkIcon}<span><strong>You've unlocked free shipping!</strong></span>`;

    bars.forEach(progressBar => {
      const progressBarElement = progressBar.querySelector('.js-shipping-progress-fill') || progressBar.querySelector('.shipping-progress-fill');
      if (progressBarElement) {
        progressBarElement.style.width = `${progressPercentage}%`;
      }
      
      const messageElement = progressBar.querySelector('.cart-free-shipping-bar__message');
      if (messageElement) {
        messageElement.classList.toggle('cart-free-shipping-bar__message--success', remainingAmount <= 0);
        messageElement.innerHTML = messageHtml;
      }
    });

    if (typeof CartShippingBar !== 'undefined' && CartShippingBar.updateShippingTime) {
      CartShippingBar.updateShippingTime();
    }
  }

  formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }

  hideAddedUpsellProduct(button) {
    const productCard = button.closest('.cart-upsell__product');
    if (productCard) {
      productCard.remove();
      const upsellContainer = document.querySelector('[data-cart-upsell]');
      const remainingProducts = document.querySelectorAll('.cart-upsell__product');
      if (upsellContainer && remainingProducts.length === 0) {
        upsellContainer.style.display = 'none';
      }
    }
  }

  filterUpsellsByCart(cart) {
    if (!cart || !cart.items) return;
    const cartProductIds = cart.items.map(item => String(item.product_id));
    const upsellProducts = document.querySelectorAll('.cart-upsell__product[data-product-id]');
    
    upsellProducts.forEach(product => {
      const productId = product.dataset.productId;
      if (cartProductIds.includes(productId) && product.dataset.allowProductInCart !== 'true') {
        product.remove();
      }
    });

    const upsellContainer = document.querySelector('[data-cart-upsell]');
    const remainingProducts = document.querySelectorAll('.cart-upsell__product');
    if (upsellContainer && remainingProducts.length === 0) {
      upsellContainer.style.display = 'none';
    }
  }

  showSuccessMessage(productTitle) {
    const message = document.createElement('div');
    message.className = 'cart-upsell-notification cart-upsell-notification--success';
    message.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" fill="currentColor"/>
      </svg>
      <span>${productTitle} added to cart</span>
    `;

    this.showNotification(message);
  }

  showErrorMessage() {
    const message = document.createElement('div');
    message.className = 'cart-upsell-notification cart-upsell-notification--error';
    message.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="currentColor"/>
      </svg>
      <span>Failed to add item to cart. Please try again.</span>
    `;

    this.showNotification(message);
  }

  showNotification(messageElement) {
    document.body.appendChild(messageElement);

    requestAnimationFrame(() => {
      messageElement.classList.add('cart-upsell-notification--visible');
    });

    setTimeout(() => {
      messageElement.classList.remove('cart-upsell-notification--visible');
      setTimeout(() => {
        messageElement.remove();
      }, 300);
    }, 3000);
  }

  subscribeToCartUpdates() {
    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.cartData) {
          this.updateProgressBar(event.cartData);
          this.filterUpsellsByCart(event.cartData);
        }
      });
    }
  }
}

function initIrCartEnhancements() {
  if (window.__irCartEnhancements) return;
  window.__irCartEnhancements = new CartEnhancements();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initIrCartEnhancements);
} else {
  initIrCartEnhancements();
}
